<div class="dialog-container">
  <div class="dialog-header">
    <div class="header-content">
      <div class="icon-box">
        <mat-icon class="settings-icon">settings</mat-icon>
      </div>
      <h2 mat-dialog-title>Alert Settings</h2>
    </div>
    <button mat-icon-button (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-body">
    
    <div *ngIf="(alertSettings | keyvalue).length === 0" class="empty-state">
      <div class="empty-icon-box">
        <mat-icon>notifications_off</mat-icon>
      </div>
      <h3>No Alert Settings Available</h3>
      <p>No alert configurations found for this device.</p>
    </div>

    <div class="settings-list" *ngIf="(alertSettings | keyvalue).length > 0">
      
      <div *ngFor="let role of alertSettings | keyvalue: originalOrder" class="role-card">
        
        <button class="role-header-btn" (click)="toggleRoleExpansion(role.key)">
          <div class="role-info">
            <mat-icon class="role-icon">notifications</mat-icon>
            <span class="role-name">{{ roleMap[role.key] || 'Role ' + role.key }}</span>
          </div>
          <mat-icon class="chevron" [class.rotated]="isExpanded(role.key)">expand_more</mat-icon>
        </button>

        <div class="role-content" *ngIf="isExpanded(role.key)">
          
          <div *ngFor="let category of role.value | keyvalue: originalOrder" class="category-section">
            
            <div class="category-header">
              <mat-icon class="category-icon">schedule</mat-icon>
              <span>{{ categoryMap[category.key] || 'Category ' + category.key }}</span>
            </div>

            <div class="table-header mobile-hidden">
              <div class="col-name">Alert Type</div>
              <div class="col-type">Type</div>
              <div class="col-trigger">Trigger</div>
              <div class="col-setting">Setting</div>
            </div>

            <div *ngFor="let alert of category.value | keyvalue: originalOrder" class="alert-row">
              
              <div class="alert-info-col">
                <span class="alert-name">{{ alertTypeMap[alert.key] || 'Alert ' + alert.key }}</span>
                <span class="badge desktop-hidden" 
                      [ngClass]="alert.value.type === 'event' ? 'badge-yellow' : 'badge-blue'">
                  <mat-icon class="badge-icon">{{ alert.value.type === 'event' ? 'bolt' : 'schedule' }}</mat-icon>
                  {{ alert.value.type === 'event' ? 'Event' : 'Time' }}
                </span>
              </div>

              <div class="mobile-hidden">
                <span class="badge" 
                      [ngClass]="alert.value.type === 'event' ? 'badge-yellow' : 'badge-blue'">
                  <mat-icon class="badge-icon">{{ alert.value.type === 'event' ? 'bolt' : 'schedule' }}</mat-icon>
                  {{ alert.value.type === 'event' ? 'Event' : 'Time' }}
                </span>
              </div>

              <div class="mobile-hidden text-muted">
                {{ alert.value.type === 'event' ? 'Event Based' : 'Time Based' }}
              </div>

              <div class="setting-col">
                <mat-form-field appearance="outline" class="custom-select">
                  <mat-select [value]="alert.value.event_counter.toString()" 
                              (selectionChange)="onSettingChange(role.key, category.key, alert.key, $event.value)">
                    <mat-option *ngFor="let opt of (alert.value.type === 'event' ? eventOptions : timeOptions)" 
                                [value]="opt.value">
                      {{ opt.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-footer">
    <div class="footer-left">
      <div *ngIf="hasChanges" class="unsaved-changes">
        <mat-icon>info</mat-icon>
        <span>Unsaved changes</span>
      </div>
    </div>
    
    <div class="footer-right">
      <button mat-stroked-button (click)="dialogRef.close()" [disabled]="updating">
        Cancel
      </button>
      <button mat-flat-button color="primary" 
              (click)="handleUpdate()" 
              [disabled]="updating || !hasChanges">
        <mat-spinner diameter="20" *ngIf="updating"></mat-spinner>
        <span *ngIf="!updating">Save</span>
      </button>
    </div>
  </div>
</div>